var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "accordion",
      attrs: { role: "tablist", "aria-multiselectable": "true" }
    },
    _vm._l(_vm.keyedPartners, function(partner, i) {
      return _c(
        "div",
        { key: partner.key, staticClass: "group-wrapper mb-3" },
        [
          _c("div", [
            _c("div", { staticClass: "heading-div row" }, [
              _c(
                "button",
                {
                  class: "tab-button btn col partner-" + i,
                  attrs: {
                    type: "button",
                    role: "tab",
                    "data-toggle": "collapse",
                    "data-target": "#collapse" + i,
                    "aria-controls": "collapse" + i,
                    "aria-expanded": true
                  }
                },
                [
                  _c("i", { staticClass: "fas fa-plus fa-lg" }),
                  _vm._v(" "),
                  _c("i", { staticClass: "fas fa-minus fa-lg" }),
                  _vm._v(" "),
                  _c("header-control", {
                    attrs: {
                      id: "partner-" + i,
                      title: _vm.$t(
                        "ContinuousReport.Collaboration.Partners.PartnerWithIndex",
                        null,
                        [i + 1]
                      ),
                      doNotUseResources: true
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.model.partners.length > 1
                ? _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip.top.center",
                          value: {
                            html: true,
                            content: _vm.$t(
                              "ContinuousReportSummary.Collaboration.Partners.DeletePartner"
                            )
                          },
                          expression:
                            "{html: true, content: $t('ContinuousReportSummary.Collaboration.Partners.DeletePartner')}",
                          modifiers: { top: true, center: true }
                        }
                      ],
                      staticClass: "btn btn-link right col-auto",
                      attrs: {
                        type: "button",
                        "aria-label":
                          _vm.$t(
                            "ContinuousReport.Collaboration.Partners.DeletePartner"
                          ) +
                          " " +
                          (i + 1) +
                          " " +
                          _vm.$t("Accessibility.ConfirmDeletePartner")
                      },
                      on: {
                        click: function($event) {
                          return _vm.deletePartner(i)
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-trash-alt fa-lg" })]
                  )
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "collapse show", attrs: { id: "collapse" + i } },
            [
              _c("partner-control", {
                attrs: {
                  partner: partner.partner,
                  targets: _vm.targets,
                  targetGroups: _vm.targetGroups,
                  index: i
                }
              })
            ],
            1
          )
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }